const CarouselAnalytics = (() => {
  const sessions = new Map();

  const getSession = (carouselId, totalSlides) => {
    if (!sessions.has(carouselId)) {
      sessions.set(carouselId, {
        viewedSlides: new Set(),
        navigationCount: 0,
        allSlidesFired: false,
        totalSlides: totalSlides || 0,
      });
    }

    const session = sessions.get(carouselId);

    if (totalSlides > 0) {
      session.totalSlides = totalSlides;
    }

    return session;
  };

  const trackGtagEvent = (name, params) => {
    if (typeof gtag !== 'function') {
      return;
    }

    gtag('event', name, params);
  };

  const recordSlideView = (carouselId, slideIndex, meta) => {
    if (!Number.isFinite(slideIndex)) {
      return;
    }

    const session = getSession(carouselId, meta.totalSlides);

    if (session.viewedSlides.has(slideIndex)) {
      return;
    }

    session.viewedSlides.add(slideIndex);

    if (meta.interactionType) {
      session.navigationCount += 1;
    }

    trackGtagEvent('spotlight_slide_view', {
      carousel_id: carouselId,
      slide_index: slideIndex,
      slide_name: meta.slideName || '',
      total_slides: session.totalSlides,
      slides_viewed_count: session.viewedSlides.size,
      interaction_type: meta.interactionType || '',
      device_layout: meta.deviceLayout || '',
    });

    if (
      !session.allSlidesFired &&
      session.totalSlides > 0 &&
      session.viewedSlides.size === session.totalSlides
    ) {
      session.allSlidesFired = true;

      trackGtagEvent('spotlight_all_slides_viewed', {
        carousel_id: carouselId,
        total_slides: session.totalSlides,
        navigation_count: session.navigationCount,
        device_layout: meta.deviceLayout || '',
      });
    }
  };

  const recordSlideClick = (carouselId, slideIndex, meta) => {
    if (!Number.isFinite(slideIndex)) {
      return;
    }

    const session = getSession(carouselId, meta.totalSlides);

    trackGtagEvent('spotlight_slide_click', {
      transport_type: 'beacon',
      carousel_id: carouselId,
      slide_index: slideIndex,
      slide_name: meta.slideName || '',
      destination_url: meta.destinationUrl || '',
      device_layout: meta.deviceLayout || '',
      slides_viewed_count: session.viewedSlides.size,
      viewed_all_slides:
        session.totalSlides > 0 && session.viewedSlides.size === session.totalSlides,
    });
  };

  const bindSpotlightClickTracking = (root, carouselId, deviceLayout, totalSlides) => {
    root.addEventListener('click', (e) => {
      const link = e.target.closest('[data-spotlight-link]');

      if (!link || link.getAttribute('href') === '#') {
        return;
      }

      const slideIndex = Number(link.dataset.slideIndex);

      recordSlideClick(carouselId, slideIndex, {
        slideName: link.dataset.slideName || '',
        destinationUrl: link.href,
        deviceLayout,
        totalSlides,
      });
    });
  };

  return {
    recordSlideView,
    recordSlideClick,
    bindSpotlightClickTracking,
  };
})();

window.CarouselAnalytics = CarouselAnalytics;
